import SelectMenuActionButton from "components/shared/selectMenuActionButton";
import { dateTimeToView } from "helpers/date";
import { idlenessStatuses, idlenessStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { enumLabel } from "helpers/system";
import { fullName } from "helpers/user";
import policy from "policies";
import React, { useMemo } from "react";
import { components } from "react-select";

const TrucksMenuList = (props) => {
    const {
        children,
        selectProps: { modal, organization, roles, profile, refuelingSettings, onChange },
    } = props;

    const canCreate = useMemo(() => {
        return policy("user", {
            user: {
                canEditAll: !organization.noAccessToEditBooks,
                intBooksEditPermissionsFlags: organization.intBooksEditPermissionsFlags,
                roles,
            },
            record: {},
            options: { book: "trucks" },
        }).canEditBook();
    }, [organization, roles]);
    const handleCreateTruck = () => {
        if (modal) {
            modal({
                name: "createTruck",
                title: "Создание машины",
                windowMod: "wide",
                canEditBooks: true,
                roles,
                profile,
                refuelingSettings,
                onSuccess: (truck) => {
                    onChange({
                        name: "carId",
                        value: truck.id,
                        option: truck,
                    });
                },
            });
        }
    };
    return (
        <>
            <components.MenuList {...props}>{children}</components.MenuList>
            {canCreate && (
                <div className="text-center border-top">
                    <SelectMenuActionButton onAction={handleCreateTruck}>Создать машину</SelectMenuActionButton>
                </div>
            )}
        </>
    );
};

const DriversMenuList = (props) => {
    const {
        children,
        selectProps: { inputProps, modal, organization, roles, onChange },
    } = props;

    const canCreate = useMemo(() => {
        return policy("user", {
            user: {
                canEditAll: !organization.noAccessToEditBooks,
                intBooksEditPermissionsFlags: organization.intBooksEditPermissionsFlags,
                roles,
            },
            record: {},
            options: { book: "drivers" },
        }).canEditBook();
    }, [organization, roles]);
    const handleCreateDriver = () => {
        if (modal) {
            modal({
                name: "createDriver",
                title: "Создание водителя",
                windowMod: "wide",
                onSuccess: (driver) => {
                    onChange({
                        name: inputProps.name,
                        value: driver.id,
                        option: { ...driver.user, fullName: fullName(driver.user) },
                    });
                },
            });
        }
    };
    return (
        <>
            <components.MenuList {...props}>{children}</components.MenuList>
            {canCreate && (
                <div className="text-center border-top">
                    <SelectMenuActionButton onAction={handleCreateDriver}>Создать водителя</SelectMenuActionButton>
                </div>
            )}
        </>
    );
};

const TrailersMenuList = (props) => {
    const {
        children,
        selectProps: { modal, organization, roles, onChange, refuelingSettings, profile },
    } = props;

    const canCreate = useMemo(() => {
        return policy("user", {
            user: {
                canEditAll: !organization.noAccessToEditBooks,
                intBooksEditPermissionsFlags: organization.intBooksEditPermissionsFlags,
                roles,
            },
            record: {},
            options: { book: "trailers" },
        }).canEditBook();
    }, [organization, roles]);
    const handleCreateTrailer = () => {
        if (modal) {
            modal({
                name: "createTrailer",
                title: "Создание прицепа",
                windowMod: "wide",
                canEditBooks: true,
                roles,
                profile,
                refuelingSettings,
                onSuccess: (trailer) => {
                    onChange({
                        name: "trailerId",
                        value: trailer.id,
                        option: trailer,
                    });
                },
            });
        }
    };
    return (
        <>
            <components.MenuList {...props}>{children}</components.MenuList>
            {canCreate && (
                <div className="text-center border-top">
                    <SelectMenuActionButton onAction={handleCreateTrailer}>Создать прицеп</SelectMenuActionButton>
                </div>
            )}
        </>
    );
};

const Option = (props) => {
    const {
        option: { startedAt, endedAt },
        label,
    } = props.data;
    return (
        <components.Option {...props}>
            {label}
            <br />
            <small>
                Период смены: {dateTimeToView(startedAt)} &mdash; {dateTimeToView(endedAt)}
            </small>
        </components.Option>
    );
};

const renderBookStatus = (bookStatus) => {
    const { lastBidId, releaseDate, status } = bookStatus || {};
    if (!status) {
        return null;
    }
    if (status === idlenessStatusesEnum.Idle) {
        return (
            <small className="align-middle">
                <i className="select-item__icon icon-uEA70-circle text-success" />
                &nbsp;
                {enumLabel(idlenessStatuses, status)}
            </small>
        );
    } else {
        return (
            <small className="align-middle">
                <i className="select-item__icon icon-uEA70-circle text-danger" />
                &nbsp;
                {enumLabel(idlenessStatuses, status)}
                &nbsp;до:&nbsp;
                {dateTimeToView(releaseDate)};&nbsp;Заявка:&nbsp;
                <a href={paths.bidShow("bid", lastBidId)} target="_blank" rel="noopener noreferrer">
                    #{lastBidId}
                </a>
            </small>
        );
    }
};

const ValueContainer = (props) => {
    const { children, getValue, hasValue, selectProps } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    {getValue()[0].label} {renderBookStatus((selectProps.extendValue || {}).carStatus)}
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

const TrailerValueContainer = (props) => {
    const { children, getValue, hasValue, selectProps } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    {getValue()[0].label} {renderBookStatus((selectProps.extendValue || {}).trailerStatus)}
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

export default {
    car: { ValueContainer, MenuList: TrucksMenuList },
    driver: { MenuList: DriversMenuList },
    trailer: { ValueContainer: TrailerValueContainer, MenuList: TrailersMenuList },
    couplings: { Option },
};
